export const _setAssetType = (state, action) => action.payload;

export const _setIsNewAssetType = (state, action) => {
  state.isNewAssetType = action.payload;
};

export const _setType = (state, action) => {
  state.type = action.payload;
};
